export const resolveBackorderDisclaimer = (portal, fulfilmentType) => {
  if (fulfilmentType === 'Dropship') {
    return portal.dropship_backorder_text
  }

  return portal.backorder_text
}
